module.exports = __webpack_public_path__ + "img/freight_yard2_1.7219899a.png";